import API from '../..';

const ENTITY = 'products-sunwise/incentive-offer-elements';

export const getItem = () => API.get(`/api/v1/${ENTITY}/`);
